<template>
  <master-main
    :exportProperties="{
      pdf: {
        filename: `${$t('labor.bonus')}.pdf`,
        route: `${getModuleRoute}/pdf`,
      },
      xls: {
        filename: `${$t('labor.bonus')}.xlsx`,
        route: `${getModuleRoute}/excel`,
      },
    }"
    :dataBadges="[
      {
        columnLabel: $t('labor.associated_workers'),
        data: 'workers',
        property: 'name',
        minWidth: 300,
      },
      {
        columnLabel: $t('common_words.associated_companies2'),
        data: 'businesses',
        property: 'name',
        minWidth: 300,
      },
      {
        columnLabel: $t('common_words.associated_modules'),
        data: 'modules',
        property: 'name',
        minWidth: 300,
        show: isSuper(),
      },
    ]"
    :route="getModuleRoute"
    :tableProperties="tableProperties"
    @closeModal="handleCloseModal"
    @openModal="handleOpenModal"
    @refresh="refresh"
    @showHideLoading="showHideLoading"
    @showNotification="notifyVue"
    ref="masterMain"
  >
    <template slot="dialogForm">
      <edit-or-create-bonus
        :syncDialog="modals"
        @addEdit="addEdit"
        @closeModal="handleCloseModal"
        @showHideLoading="showHideLoading"
        @showNotification="notifyVue"
        ref="editCreate"
      />
    </template>
  </master-main>
</template>
<script>
import BonusesTable from './bonuses-table';
import EditCreate from './EditCreate.vue';
import i18n from 'src/i18n';
import MasterMain from 'src/components/Layouts/Masters/MasterMain.vue';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinMain from 'src/mixins/master/mixin-main';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinWithDialog from 'src/mixins/master/mixin-with-dialog';

export default {
  components: { MasterMain, [EditCreate.name]: EditCreate },
  data() {
    return {
      tableProperties: {},
    };
  },
  mixins: [
    MixinAlert,
    MixinLoading,
    MixinMain,
    MixinPermissions,
    MixinWithDialog,
  ],
  computed: {
    getModuleRoute() {
      return 'works/bonuses';
    },
    buildTableProperties() {
      return {
        tableColumns: [...BonusesTable().tableColumns],
        model: 'bonus',
        effectTags: 'dark',
        widthColumnStatus: 160,
        defaultSort: { prop: 'name', order: 'ascending' },
        addColumns: [
          {
            data: 'bonus_values',
            label: i18n.t('labor.value_history'),
            field: 'info',
          },
          {
            data: 'asociated_activities',
            label: i18n.t('labor.associated_activities'),
            field: 'name',
          },
          {
            data: 'excluded_activities',
            label: i18n.t('labor.excluded_activities'),
            field: 'name',
          },
          {
            data: 'discount_saturdays_activities',
            label: i18n.t('labor.discount_saturday'),
            field: 'name',
          },
          {
            data: 'discount_sundays_activities',
            label: i18n.t('labor.discount_sunday'),
            field: 'name',
          },
          {
            data: 'workers',
            label: i18n.t('labor.associated_workers'),
            field: 'name',
          },
        ],
      };
    },
  },
};
</script>
